import { Modal, Typography, Card, Box, Grid, IconButton, Icon } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CancelIcon from '../../../icons/cancelIcon.svg';
import { UpdateOwnerStatusEnum } from '@inosio/payments-sdk';
import { LoadingButton } from '@mui/lab';

const useStyles = makeStyles({
  modalContainer: {
    background: '#FFFFFF',
    boxShadow: 'none',
    borderRadius: '24px',
  },
  titleText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '600 !important',
    fontSize: '18px !important',
    lineHeight: '22px !important',
    color: '#000000 !important',
    textAlign: 'center',
  },
  detailsText: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '18px !important',
    lineHeight: '21px !important',
    color: '#000000 !important',
  },
  buttonContainer: {
    position: 'absolute',
    bottom: '20px',
    width: '92%',
    display: 'flex',
    justifyContent: 'center',
  },
  globalError: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '600 !important',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#DB3939',
    textAlign: 'center',
    borderTop: '2px  solid #DB3939',
    borderRadius: '24px',
    padding: '12px 20px',
    width: '100%',
    margin: '0px auto',
  },
});

interface OwnerStatusChangeModalProps {
  open: boolean;
  closeCallback: () => void;
  confirmCallback: () => void;
  status: UpdateOwnerStatusEnum;
  isChangingStatus: boolean;
  errorMessage: string | null;
}

export default function OwnerStatusChangeModal(props: OwnerStatusChangeModalProps) {
  const classes = useStyles();
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '16px',
    minHeight: '523px',
    pointerEvents: 'auto',
    width: '98%',
    maxWidth: '472px',
    borderRadius: '24px',
    outline: 'none',
  };

  return (
    <div className={`${classes.modalContainer}`}>
      <Modal
        open={props.open}
        onClose={(e, reason) => reason !== 'backdropClick' && props.closeCallback()}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        BackdropProps={{
          invisible: false,
        }}
        disableEscapeKeyDown
      >
        <Card sx={style}>
          <Grid container>
            <Grid item xs={2}></Grid>
            <Grid item xs={8}>
              <Typography className={classes.titleText} sx={{ mt: 1 }}>
                {props.status === UpdateOwnerStatusEnum.Deactivate ? 'Deactivate Owner' : 'Reactivate Owner'}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <IconButton sx={{ ml: '30px' }} onClick={() => props.closeCallback()}>
                <Icon>
                  <img src={CancelIcon} alt="" width={24} height={24} />
                </Icon>
              </IconButton>
            </Grid>
          </Grid>
          {!!props.errorMessage?.length && (
            <Box sx={{ mx: 3 }}>
              <Typography className={classes.globalError}>{props.errorMessage}</Typography>
            </Box>
          )}
          <Box mt={10}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography className={classes.detailsText}>{`This owner will move to your list of ${props.status === UpdateOwnerStatusEnum.Deactivate ? 'inactive' : 'active'} owners.`}</Typography>
            </Box>
            {props.status === UpdateOwnerStatusEnum.Deactivate && (
              <Box sx={{ textAlign: 'center', mt: 3, mb: 8, px: 5 }}>
                <Typography className={classes.detailsText} sx={{ fontWeight: '300 !important', color: '#14142B !important' }}>
                  They will maintain access to their account if they have it, but will receive no further automated communication from Inosio.
                </Typography>
              </Box>
            )}
            <div className={classes.buttonContainer}>
              <LoadingButton
                loading={props.isChangingStatus}
                variant="outlined"
                sx={{
                  width: '80%',
                  borderRadius: '24px',
                  fontFamily: 'Work Sans !important',
                  textTransform: 'capitalize',
                  color: props.status === UpdateOwnerStatusEnum.Deactivate ? 'red' : '#39A2DB',
                  borderColor: props.status === UpdateOwnerStatusEnum.Deactivate ? 'red' : '#39A2DB',
                  '&:hover': {
                    backgroundColor: props.status === UpdateOwnerStatusEnum.Deactivate ? 'rgba(255, 0, 0, 0.1)' : 'rgba(57, 162, 219, 0.1)', // Light background on hover
                    borderColor: props.status === UpdateOwnerStatusEnum.Deactivate ? 'red' : '#39A2DB',
                    color: props.status === UpdateOwnerStatusEnum.Deactivate ? 'red' : '#39A2DB',
                  },
                }}
                onClick={props.confirmCallback}
              >
                {props.status === UpdateOwnerStatusEnum.Deactivate ? 'Deactivate Owner' : 'Reactivate Owner'}
              </LoadingButton>
            </div>
          </Box>
        </Card>
      </Modal>
    </div>
  );
}
